<template>
    <ui-card-toggle
        design="brightness"
        set-status
        :open="true"
    >
        <template #title>
            <div class="title-container">
                <ui-user-lock-icon />
                <span class="title">Alterar Responsáveis em Massa</span>
            </div>
        </template>
        <template #content>
            <div class="area-card">
                <div v-if="!loading && groups.length">
                    <div class="header-content">
                        <div class="switch-all-users">
                            <ui-switch
                                v-model="checkedAllUsers"
                                :checked="checkedAllUsers"
                                design="xs"
                            />
                            Permitir que grupos de usuários possam alterar responsáveis de múltiplos negócios.
                        </div>
                        <div 
                            v-if="checkedAllUsers"
                            class="diviser" 
                        />

                        <div v-if="checkedAllUsers" class="container-switch">
                            <div v-for="(group, index) in groups" :key="index" class="switch-card">
                                <span>{{ group.name }}</span>
                                <ui-switch v-model="group.enabled" :checked="group.enabled" design="xs" />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div v-else  class="loading-container">
                    <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                </div>
            </div>
            <div class="diviser"/>
            <div class="footer-card">
                <ui-button 
                    design="md success" 
                    :disabled="!canSubmit" 
                    :loading="loading || loadingSubmit || !groups.length" 
                    @click="submit"
                >
                    Salvar
                </ui-button>
            </div>
        </template>
    </ui-card-toggle>
</template>
<script>
    import { uiCardToggle } from '@/components/ui/cards'
    import { uiButton } from '@/components/ui/buttons'
    import { funnel } from '@/services/axios'
    import { uiSwitch } from '@/components/ui/form';
    import { uiLoadIndicator } from '@/components/ui';
    import { uiUserLockIcon } from '@/components/ui-icons';
import { storage } from '@/services/storage';

    export default {
        name: 'change-responsible-in-bulk',

        components: {
            uiButton,
            uiSwitch,
            uiLoadIndicator,
            uiCardToggle,
            uiUserLockIcon,
        },

        props: {
          rawGroups: {
            type: Array,
            required: true
          }
        },

        data() {
            return {
                loading: true,
                loadingSubmit: false,
                groups: [],
                isUsersCanDuplicateDeals: false,
                checkedAllUsers: false,
                // variável para guardar os dados iniciais dos grupos para comparar se algo mudou
                //  e caso tenha mudado tirar o botao do disabled
                defaultGroups: [],
                lastCheckedAllUsers: false
            }
        },

        computed: {
            canSubmit() {
                const groupsChanged = this.groups.some((group, i) =>
                    group.enabled !== this.defaultGroups[i]?.enabled
                )
                const activeChanged = this.checkedAllUsers !== this.lastCheckedAllUsers
                        
                return groupsChanged || activeChanged
            }
        },

        watch: {
            rawGroups: {
                immediate: true,
                handler(newVal) {
                    if (newVal && newVal.length) {
                        this.prepareGroups()
                    }
                    this.$nextTick(() => {
                        this.loading = false
                    })
                }
            }
        },

        mounted() {
            const userLogged = JSON.parse(storage.get('user_logged') || '{}')
            this.checkedAllUsers = !!(userLogged.config_permissions?.bulkActionChangeDealOwner)

            if (this.rawGroups && this.rawGroups.length) {
                this.prepareGroups()
            }
            this.$nextTick(() => {
                this.loading = false
            })
        },


        methods: {
            prepareGroups() {
              const allowedNames = ['admin', 'manager', 'supervisor']

              this.groups = this.rawGroups
                .filter(group => allowedNames.includes(group.name))
                .map(group => {
                    const hasChangeOwnerPermission = group.permissions['funnel.deal.*.change.owner'] === 1
                
                    return ({
                        id: group.id,
                        name: this.switchGroup(group.name),
                        enabled: !!hasChangeOwnerPermission
                    })
                })
                .sort((a, b) => a.name.localeCompare(b.name))
            
              // Setar os valores de comparação
              this.defaultGroups = JSON.parse(JSON.stringify(this.groups))
              this.lastCheckedAllUsers = this.checkedAllUsers
            },


            // Verifica se a chave corresponde ao padrão "funnel.deal.*.copie" e se seu valor é 1
            verifyIsAllowed(groupPermissions){
                const isPermission = Object.keys(groupPermissions).some(key => {
                    return /^funnel\.deal\..+\.copie$/.test(key) && groupPermissions[key] === 1;
                })
                return isPermission
            },

            switchGroup(groupName) {
                switch (groupName) {
                    case 'system':
                        return 'Sistema'
                    case 'admin':
                        return `Administrador`
                    case 'manager':
                        return `Gerente`
                    case 'supervisor':
                        return `Supervisor`
                    case 'broker':
                        return `Corretor`
                    case 'collaborator':
                        return `Colaborador`
                    default:
                        return groupName
                }
            },


            async submit() {
              this.loadingSubmit = true
              await funnel.updateAllowBulkChangeDealOwner({
                active: this.checkedAllUsers,
                    groups: this.groups.map(group => ({
                        id: group.id,
                        bulkChangeDealOwner: group.enabled
                    }))
              })
                .then(data => {
                    this.defaultGroups = JSON.parse(JSON.stringify(this.groups))
                    this.lastCheckedAllUsers = this.checkedAllUsers
                    this.$toastr.s(data.data.msg)

                    let userLogged = JSON.parse(storage.get('user_logged') || '{}')

                    if (!userLogged.config_permissions || Array.isArray(userLogged.config_permissions)) {
                    userLogged.config_permissions = {}
                    }

                    userLogged.config_permissions.bulkActionChangeDealOwner = this.checkedAllUsers ? 1 : 0

                    storage.set('user_logged', JSON.stringify(userLogged))
                })
                .catch(error => {
                  if (error.data && error.data.msg) {
                    this.$toastr.e(error.data.msg)
                  }
                })
                .finally(() => {
                  this.loadingSubmit = false
                })
            }

        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
